export default "__VITE_ASSET__Cui6aQ5T__"